import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import Captcha from '../../Common/Captcha';

import {putUserPassword} from '../../../actions/user.actions';
import {Button, ButtonGroup, PageContainer, PageDescription, PageTitle, Table} from '../../Common/PageComponents';

const stateToProps = state => {
  return {
    username: state.user.username,
  };
};

class PasswordChange extends Component {
  componentDidMount() {
    this.form.currentPassword.focus();
  }

  _preparePasswordChanging(e) {
    e.preventDefault();

    let {currentPassword, newPassword, newPasswordConfirm} = this.form;

    if (!currentPassword.value) {
      alert('현재 비밀번호를 입력해주세요.');
      currentPassword.focus();
      return;
    }

    if (!newPassword.value) {
      alert('새 비밀번호를 입력해주세요.');
      newPassword.focus();
      return;
    }

    if (!newPasswordConfirm.value) {
      alert('새 비밀번호를 한 번 더 입력해주세요.');
      newPasswordConfirm.focus();
      return;
    }

    if (currentPassword.value === newPassword.value) {
      alert('현재 비밀번호와 다른 새 비밀번호를 입력해주세요.');
      newPassword.focus();
      return;
    }

    if (newPassword.value && newPassword.value !== newPasswordConfirm.value) {
      alert('새 비밀번호 확인란에 새 비밀번호와 동일한 비밀번호를 입력해주세요.');
      newPasswordConfirm.focus();
      return;
    }
    this.captchaRef.execute();
  }

  _changePassword(captchaToken) {
    if (captchaToken === undefined || captchaToken === '') {
      window.alert('Captcha token에 문제가 있습니다. 다시 진행해 주세요.');
      return;
    }
    this.props.dispatch(
      putUserPassword(
        this.form.currentPassword.value,
        this.form.newPassword.value,
        captchaToken,
        this.captchaRef,
        this.props.history
      )
    );
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title={'비밀번호변경'} />
        <PageDescription>
          회원정보 수정 후 90일이 초과된 회원님은 개인정보 보안 강화를 위해 반드시 비밀번호를 변경하셔야 합니다.
        </PageDescription>
        <form ref={form => (this.form = form)} name="form1" autoComplete="off">
          <Table theme="form">
            <colgroup>
              <col width={140} />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th>아이디</th>
                <td>{this.props.username}</td>
              </tr>
              <tr>
                <th>현재 비밀번호</th>
                <td>
                  <input
                    type="password"
                    className="input_text"
                    maxLength={16}
                    id="currentPassword"
                    name="currentPassword"
                    autoComplete="off"
                  />
                </td>
              </tr>
              <tr>
                <th>새 비밀번호</th>
                <td>
                  <input
                    type="password"
                    className="input_text"
                    maxLength={16}
                    id="newPassword"
                    name="newPassword"
                    autoComplete="off"
                  />
                </td>
              </tr>
              <tr>
                <th>새 비밀번호 확인</th>
                <td>
                  <input
                    type="password"
                    className="input_text"
                    maxLength={16}
                    id="newPasswordConfirm"
                    name="newPasswordConfirm"
                    autoComplete="off"
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
        <ButtonGroup>
          <Captcha
            ref={captchaRef => (this.captchaRef = captchaRef)}
            onVerify={captchaToken => this._changePassword(captchaToken)}
          />
          <Button onClick={e => this._preparePasswordChanging(e)}>등록</Button>
          <Link to="/">
            <Button theme="gray">취소</Button>
          </Link>
        </ButtonGroup>
      </PageContainer>
    );
  }
}

export default withRouter(connect(stateToProps)(PasswordChange));
